import type { SearchGames } from "~/types/game"

export const searchStore = defineStore('search', {
  state: (): SearchGames => ({
    searchText: ''
  }),
  persist: false,
  actions: {
    setSearchText(searchText: string) {
      this.searchText = searchText
    },
    getSearchText(): string {
      return this.searchText
    },
    resetSearchText() {
      this.searchText = ''
    }
  }
})
